import React from "react";
import "./sub.css";
import Helmet from 'react-helmet'
import contactConfig from "../confi";
const PrivacyPolicy = () => {
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  return (
<>
<Helmet>
  <title>
    Privacy Policy | JP Home Services – Domestic Help & Caretaker Agency
  </title>

  <meta
    name="description"
    content="Read JP Home Services Privacy Policy to understand how we collect, use, and protect your personal information for maid, cook, babysitter, and caretaker services in Ahmedabad."
  />

  <meta
    name="keywords"
    content="JP Home Services privacy policy, maid service privacy policy, home service agency privacy, domestic help data protection, caretaker service privacy India, Ahmedabad home services policy"
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.jphomeservices.com/privacy-policy"
  />
  <meta property="og:type" content="website" />
<meta property="og:site_name" content="JP Home Services" />

</Helmet>
        <section className="about-hero">
            <div className="hero-content1">
                <h1>Privacy Policy</h1>
            </div>
        </section>
    <div className="privacy-policy-container">
      <div className="floating-contact-icons">
            <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
              </svg>
            </div>
            <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
          </div>
      <div className="privacy-policy-content">
        <section className="privacy-policy-section">
          <p className="privacy-policy-intro">
            Welcome to <strong className="text-primary-purple">J P Home Services</strong> ("we", "our", "us").
            We value your privacy and are committed to protecting your personal
            information. This Privacy Policy outlines how we collect, use, and
            safeguard the information you share with us through our website and
            services.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">1. Information We Collect</h2>
          </div>
          <p className="privacy-policy-text">
            We may collect personal details such as your name, phone number,
            email address, location, and service requirements when you fill out
            our online forms, request a quote, or contact us. We may also
            collect non-personal information like browser type, device, and IP
            address to enhance your browsing experience.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">2. How We Use Your Information</h2>
          </div>
          <ul className="privacy-policy-list">
            <li className="privacy-policy-list-item">To process your service requests or bookings.</li>
            <li className="privacy-policy-list-item">To verify and match you with suitable staff members.</li>
            <li className="privacy-policy-list-item">To send service confirmations, updates, and support messages.</li>
            <li className="privacy-policy-list-item">
              To improve our website, services, and communication experience.
            </li>
            <li className="privacy-policy-list-item">
              To comply with legal obligations and ensure user and staff safety.
            </li>
          </ul>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">3. Information Sharing</h2>
          </div>
          <p className="privacy-policy-text">
            We do not sell, rent, or trade your personal data. However, we may
            share necessary information with:
          </p>
          <ul className="privacy-policy-list">
            <li className="privacy-policy-list-item">Our verified service staff or partners for service delivery.</li>
            <li className="privacy-policy-list-item">
              Legal authorities if required under applicable laws or regulations.
            </li>
            <li className="privacy-policy-list-item">Technology or marketing partners who support our operations.</li>
          </ul>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">4. Cookies</h2>
          </div>
          <p className="privacy-policy-text">
            Our website uses cookies to enhance user experience, analyze website
            traffic, and personalize content. You may disable cookies through
            your browser settings, but this could affect some functionalities.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">5. Data Security</h2>
          </div>
          <p className="privacy-policy-text">
            We implement reasonable administrative and technical measures to
            protect your data from unauthorized access, misuse, or disclosure.
            However, no online platform is completely secure, and we cannot
            guarantee absolute security of data transmission.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">6. Links to Other Websites</h2>
          </div>
          <p className="privacy-policy-text">
            Our website may contain links to third-party sites. J P Home
            Services is not responsible for the privacy practices or content of
            external websites. We encourage users to review the privacy policies
            of any linked sites before sharing information.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">7. Your Consent</h2>
          </div>
          <p className="privacy-policy-text">
            By using our website or providing your personal details, you consent
            to the collection and use of your information as outlined in this
            Privacy Policy.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">8. Policy Updates</h2>
          </div>
          <p className="privacy-policy-text">
            We may update this Privacy Policy periodically. Any changes will be
            posted on this page with an updated "Last Updated" date. Please
            check this page regularly for updates.
          </p>

          <div className="privacy-policy-section-heading">
            <h2 className="privacy-policy-section-title">9. Contact Us</h2>
          </div>
          <p className="privacy-policy-text">
            For questions or concerns regarding this Privacy Policy, contact us
            at:
          </p>
          <div className="privacy-policy-contact-info">
            <div className="privacy-policy-contact-details">
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">📞</span>
                <span className="privacy-policy-contact-text">{contactConfig.phone}</span>
              </div>
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">📧</span>
                <span className="privacy-policy-contact-text">{contactConfig.email}</span>
              </div>
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">🏢</span>
                <span className="privacy-policy-contact-text">JP Home Services,B-318 Swaminarayan Avenue,Nr. AEC Cross Road, Naranpura, Ahmedabad, Gujarat - 380013</span>
              </div>
            </div>
          </div>    
        </section>
      </div>
    </div>
</>
  );
};

export default PrivacyPolicy;